import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import customerDetailModel from '@/models/data-management/customer-detail'
import router from '@/router'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import { onBeforeMount, reactive } from '@vue/composition-api'

export default function usePointHistory() {
  const { fetchPointHistoryList } = customerDetailModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openWarningModal,
    openSuccessModal,
    openDefaultErrorModal,
  } = useValidationModal()

  const formData = reactive({
    customerId: 0,
    payload: [],
  })

  const loading = reactive({
    tableData: false,
  })

  const fields = [
    { key: 'no', label: 'ลำดับ' },
    { key: 'date', label: 'วันที่', sortable: true },
    { key: 'time', label: 'เวลา', sortable: true },
    { key: 'point', label: 'จำนวนแต้ม', sortable: true },
    { key: 'point_src', label: 'ที่มาของแต้ม', sortable: true },
  ]

  const resolveDate = dateStr => {
    const date = new Date(dateStr)

    return `${fixedNum(date.getDate(), 2)}/${fixedNum(
      date.getMonth() + 1,
      2,
    )}/${date.getFullYear()}`
  }

  const resolveTime = dateStr => {
    const date = new Date(dateStr)

    return `${fixedNum(date.getHours(), 2)}:${fixedNum(
      date.getMinutes(),
      2,
    )} น.`
  }

  const fixedNum = (number, pad) => number.toString().padStart(pad, '0')

  const fetchPointHistoryListFunc = () => {
    loading.tableData = true
    fetchPointHistoryList.payload.Customer_Id = formData.customerId
    // fetchPointHistoryList.payload.Page = pagination.currentPage
    // fetchPointHistoryList.payload.Limit = pagination.perPage
    // fetchPointHistoryList.payload.Filters = filters
    // fetchPointHistoryList.payload.Ordering = ordering.value

    store
      .dispatch('api/apiRequest', fetchPointHistoryList)
      .then(resp => {
        const respData = resp.data

        formData.payload = respData.payload
        // pagination.rows = respData.payload.length
        // pagination.totalRows = respData.filtered_record
      })
      .catch(err => {
        openDefaultErrorModal()
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  onBeforeMount(() => {
    if (!router.currentRoute.query.customerid) return
    formData.customerId = parseInt(router.currentRoute.query.customerid)
    fetchPointHistoryListFunc()
  })

  // watch(
  //   pagination,
  //   () => {
  //     if (!loading.tableData) {
  //       fetchPointHistoryListFunc()
  //     }
  //   },
  //   { deep: true },
  // )

  // watch(
  //   [filters, ordering],
  //   () => {
  //     pagination.currentPage = 1

  //     fetchPointHistoryListFunc()
  //   },
  //   { deep: true },
  // )

  return {
    formData,
    fields,
    loading,
    pagination,
    resolveDate,
    resolveTime,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
  }
}
